import { Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DealsHistoryTableRow from './DealsHistoryTableRow';
import { StrategyDeal } from 'model/modules/strategies/strategies';

interface Props {
  items: StrategyDeal[];
}

const DealsHistoryTable: FC<Props> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <TableContainer w="100%">
      <Table>
        <Thead>
          <Tr>
            <Th>{t('dealsHistoryTableTicker')}</Th>
            <Th>{t('dealsHistoryTableDate')}</Th>
            <Th>{t('dealsHistoryTableQuantity')}</Th>
            <Th>{t('dealsHistoryTableResult')}</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map((item, index) => (
            <DealsHistoryTableRow
              key={index}
              {...item}
            />
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default DealsHistoryTable;
